// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyLocation_container__Wosvc","addressTitle":"CompanyLocation_addressTitle__hLc4R","addressText":"CompanyLocation_addressText__y9Hne"};